import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[invdWholeNumberOnly]',
})
export class NumberOnlyDirective {
  @HostListener('keypress', ['$event']) onKeyDown(event) {
    if (!this.restrictNumeric(event)) {
      event.preventDefault();
    }
  }

  private restrictNumeric(e: any): boolean {
    if (e.metaKey || e.ctrlKey) {
      return true;
    }
    if (e.which === 32) {
      return false;
    }
    if (e.which === 0) {
      return true;
    }
    if (e.which < 33) {
      return true;
    }
    const input = String.fromCharCode(e.which);
    return !!/[\d\s]/.test(input);
  }
}
